import { IonContent, IonPage } from '@ionic/react'
import React, { useState, useEffect } from 'react'
import Header from '../../components/Header'
import './index.css'
import SearchBar from '../../components/SearchBar'
import {
    getReplyObjects,
    getContacts,
    ObjectType,
    ContactObject,
    updateReplyObjects,
} from '../../service/api/bot'
import { useHistory } from 'react-router'
import ContactItem from '../../components/ContactCell'
import EventEmitter from '../../utils/event'
interface ContactInfo extends ContactObject {
    selected?: boolean
}
const Contacts: React.FC = () => {
    const history = useHistory()
    const { type, option, pages, selectedList } = history.location.state
        ? (history.location.state as {
              type: ObjectType
              option: 'add' | 'sub'
          })
        : ({
              type: 'GROUP',
              option: 'add',
          } as any)
    // console.log('contact history', history.location.state)
    const [searchValue, setSearchValue] = useState('')
    // const [contats, setContacts] = useState<ContactObject[]>([])
    // const [obje, setContacts] = useState<ContactObject[]>([])
    const [realContacts, setRealContacts] = useState<ContactInfo[]>([])
    const [replyObjects, setReplyObjects] = useState<ContactObject[]>([])
    const [selectedContacts, setSelectedContacts] = useState<ContactInfo[]>([])
    const [searchedContacts, setSearchedContacts] = useState<ContactInfo[]>([])
    useEffect(() => {
        if (searchValue) {
            console.log(searchValue)
            let searchedList = realContacts
                .filter((item) => {
                    return item.name.indexOf(searchValue) > -1
                })
                .map((item) => ({
                    ...item,
                    name: item.name.replace(
                        searchValue,
                        `<em>${searchValue}</em>`
                    ),
                }))
            setSearchedContacts(searchedList)
        } else {
            loadReplyObjects()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue])
    // useEffect(() => {
    //     if (realContacts) {
    //         setSelectedContacts(realContacts.filter((item) => item.selected))
    //     }
    // }, [realContacts])
    const loadReplyObjects = async () => {
        try {
            let objectsRes = await getReplyObjects(type)

            let objects = objectsRes.wechaty_reply_object_list
            // console.log(option, objects)
            setReplyObjects(objects)
            if (option === 'add') {
                if (pages === 'schedule') {
                    let contactsRes = await getContacts({
                        contacts_type: type,
                    })
                    let contacts = contactsRes.wechaty_contacts_list
                    setSelectedContacts(selectedList)
                    setReplyObjects(selectedList)
                    setRealContacts(contacts)
                } else {
                    let contactsRes = await getContacts({
                        contacts_type: type,
                    })
                    let contacts = contactsRes.wechaty_contacts_list
                    let realData = contacts.filter((con) => {
                        return (
                            objects.filter((obj) => con.uid === obj.uid)
                                .length === 0
                        )
                    })
                    setRealContacts(realData)
                }
            }
            if (option === 'sub') {
                if (pages === 'schedule') {
                    setRealContacts(selectedList)
                    setReplyObjects(selectedList)
                    return
                }
                setRealContacts(objects)
            }
        } catch (error) {
            console.error(error)
        }
    }
    const parseContactInfoToObject = (arr: ContactInfo[]) => {
        return arr.map((item: ContactObject) => {
            return {
                uid: item.uid,
            }
        })
    }
    const onConfirm = async () => {
        try {
            if (!selectedContacts.length) return
            let objectsList: { uid: string }[] = []
            if (option === 'add') {
                objectsList = parseContactInfoToObject([
                    ...replyObjects,
                    ...selectedContacts,
                ])
            }
            if (option === 'sub') {
                objectsList = replyObjects.filter((item) => {
                    return (
                        selectedContacts.filter((selectItem) => {
                            return item.uid === selectItem.uid
                        }).length === 0
                    )
                })
            }
            if (pages === 'schedule') {
                EventEmitter.emit('selectGroup', objectsList, type)
            } else {
                await updateReplyObjects({
                    reply_object_type: type,
                    wechaty_reply_object_list: objectsList,
                })
            }
            history.goBack()
        } catch (error) {
            console.error(error)
        }
    }
    return (
        <IonPage>
            <IonContent className='contacts-content'>
                <Header
                    title={
                        type === 'GROUP'
                            ? option === 'add'
                                ? '添加群'
                                : '移除群'
                            : option === 'add'
                            ? '添加好友'
                            : '移除好友'
                    }
                >
                    {option === 'add' && (
                        <button
                            className={`contact-option-button add ${
                                selectedContacts.length > 0 ? 'active' : ''
                            }`}
                            onClick={onConfirm}
                        >
                            确定
                        </button>
                    )}
                    {option === 'sub' && (
                        <button
                            className={`contact-option-button delete ${
                                selectedContacts.length > 0 ? 'active' : ''
                            }`}
                            onClick={onConfirm}
                        >
                            移除
                        </button>
                    )}
                </Header>
                <SearchBar
                    position='relative'
                    placeholder={
                        type === 'GROUP' ? '请输入群名' : '请输入好友昵称'
                    }
                    onChange={setSearchValue}
                    onCancel={() => {
                        setSearchValue('')
                    }}
                />
                <div className='contact-content-list'>
                    {(searchValue ? searchedContacts : realContacts).map(
                        (item) => (
                            <ContactItem
                                key={item.uid}
                                selected={
                                    selectedContacts.filter(
                                        (selectItem) =>
                                            item.uid === selectItem.uid
                                    ).length > 0
                                }
                                onSelect={() => {
                                    if (
                                        selectedContacts.filter(
                                            (selectItem) =>
                                                item.uid === selectItem.uid
                                        ).length
                                    ) {
                                        setSelectedContacts(
                                            selectedContacts.filter(
                                                (selectItem) =>
                                                    item.uid !== selectItem.uid
                                            )
                                        )
                                    } else {
                                        setSelectedContacts([
                                            ...selectedContacts,
                                            item,
                                        ])
                                    }
                                    // setRealContacts(
                                    //     realContacts.map((cont) => {
                                    //         if (cont.uid === item.uid)
                                    //             cont.selected = !cont.selected
                                    //         return cont
                                    //     })
                                    // )
                                }}
                                nickname={item.name}
                                avatar={item.head_url}
                            />
                        )
                    )}
                </div>
            </IonContent>
        </IonPage>
    )
}

export default Contacts
